import { api } from '@/f1/service';
import * as forge from 'node-forge'
import * as _ from 'lodash'
import reg from '@/f1/reg'

import Language from './language';
import '../login.css';

const i18n_msg = {
  otpToken_1: {
    EN : () => `Plz, Typing email.`,
    KO : () => `이메일을 입력하세요..`,
  },
  otpToken_2: {
    EN : () => `typing was not email format`,
    KO : () => `이메일 형식에 맞춰 입력해주세요..`,
  },
  otpToken_3: {
    EN : () => `reset failed`,
    KO : () => `초기화 실패.`,
  },
  otpToken_4: {
    EN : () => `Auth token expire later 3 min`,
    KO : () => `인증실패 3분후에 다시 시도하세요.`,
  },
  otpVerify_1: {
    EN : () => `not allowed, try request auth email again`,
    KO : () => `허용되지 않습니다. 인증 이메일을 다시 요청하세요..`,
  },
  otpVerify_2: {
    EN : () => `Authorize successfully`,
    KO : () => `인증 성공.`,
  },
  otpVerify_3: {
    EN : () => `Username required.`,
    KO : () => `아이디를 입력하세요.`,
  },
  newPassword_1: {
    EN : () => `Typing new password`,
    KO : () => `새로운 패스워드를 입력하세요.`,
  },
  newPassword_2: {
    EN : () => `Typing new password repeat`,
    KO : () => `새로운 패스워드확인을 입력하세요..`,
  },
  newPassword_3: {
    EN : () => `not same password and password repeat`,
    KO : () => `새로운 암호가 다릅니다..`,
  },
  newPassword_4: {
    EN : () => `Please check password policy`,
    KO : () => `비밀번호 정책을 확인하세요.`,
  },
  newPassword_5: {
    EN : () => `check password typing alphabet.`,
    KO : () => `비밀번호 입력을 확인하세요..`,
  },
  newPassword_6: {
    EN : () => `check password typing spacial.`,
    KO : () => `비밀번호가 공백입니다.`,
  },
  newPassword_7: {
    EN : () => `check password typing number.`,
    KO : () => `비밀번호에 숫자를 포함하세요..`,
  },
  newPassword_8: {
    EN : () => `password length more then.`,
    KO : () => `비밀번호 길이가 부족합니다..`,
  },
  newPassword_9: {
    EN : () => `require group info.`,
    KO : () => `그룹정보가 필요합니다..`,
  },
  newPassword_10: {
    EN : () => `changed successfully`,
    KO : () => `비밀번호 변경 성공.`,
  }
};

export default {
  components: { Language },
  data: function () {
    return {
      // i18n_msg,
      checked: false,
      error: '',
      model: { username: '', password: '' },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false, min_length : 10  },
      group_password_policy : {},
      lock: false,
      lock_btn : false,
      reset : false
    }
  },
  computed: {
    // i18n_data() { return _i18n_data; }
    // ts() { return this.$ts(wordset, this.$store.getters.lang) }
  },
  methods: {
    password_policy(type = '')
    {
      switch (type) {
        case 'number':
          this.password_meter.is_number = this.model.password_new && reg.reg_number.test(this.model.password_new) ? true : false;
          return this.password_meter.is_number;
        case 'uppercase':
          this.password_meter.is_alphabat_upper = this.model.password_new && reg.reg_alphabat_upper.test(this.model.password_new) ? true : false;
          return this.password_meter.is_alphabat_upper;
        case 'lowercase':
          this.password_meter.is_alphabat_lower = this.model.password_new && reg.reg_alphabat_lower.test(this.model.password_new) ? true : false;
          return this.password_meter.is_alphabat_lower;
        case 'spacial':
          this.password_meter.is_spacial = this.model.password_new && reg.reg_spacial.test(this.model.password_new) ? true : false;
          return this.password_meter.is_spacial;
        case 'length':
          this.password_meter.check_length = (this.model.password_new && this.model.password_new.length >= this.password_meter.min_length) ? true : false
          return this.password_meter.check_length;
        // eslint-disable-next-line no-case-declarations
        case 'all':
          let keys = Object.keys(this.password_meter);
          for (let i = 0; i < keys.length; i++) {
            // if has can't pass
            if(!this.password_meter[keys[i]]) { return { is_error : true, key : keys[i] }; }
          }
          // all pass
          return { is_error : false };
        default:
          return false;
      }
    },
    otpToken: function () {
      this.error = '';
      if(_.isEmpty(this.model.username)) { return this.$toastr.e(i18n_msg['otpToken_1'][this.LangStatus] || 'Plz, Typing email'); }
      if(!reg.email.test(this.model.username)) { return this.$toastr.w(i18n_msg['otpToken_2'][this.LangStatus] || 'typing was not email format');}

      this.model.url = location.hostname == 'localhost' ? `${location.protocol}//${location.host}/#/reset` : `${location.protocol}//${location.hostname}:${location.port}/#/reset`
      this.lock = true;
      this.lock_btn = true;
      api.auth.tokenReset(this.model).then((rs) => {
        if(rs.error) { return this.$toastr.e(i18n_msg['otpToken_3'][this.LangStatus] || "reset failed") }
        setTimeout(() => {
          this.lock_btn = false;
        }, 3 * 60 * 1000);
        this.$toastr.i(i18n_msg['otpToken_4'][this.LangStatus] || 'Auth token expire later 3 min');
        window.localStorage.setItem('username', this.model.username)

      }).catch(e => { console.log(e); this.lock_btn = false; this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)});
    },
    otpVerify: async function (token = this.$route.query.token, username = this.$route.query.username) {
      // console.log("token11", token)
      if(!token) { return; }
      await api.auth.tokenVerify({ token : token }).then((rs) => {
        if(!rs) {
          this.$toastr.e(i18n_msg['otpVerify_1'][this.LangStatus] || "expired, not allowed, try request auth email again")
        } else {
          if(rs && rs.password_min_len > 0) {
            this.group_password_policy = rs;
            this.password_meter.min_length = this.group_password_policy.password_min_len < this.password_meter.min_length ? this.password_meter.min_length : this.group_password_policy.password_min_len
          }
          if(username) { this.model.username = username.replace(/ /g, '+') } // bug?
          this.reset = true; return this.$toastr.i(i18n_msg['otpVerify_2'][this.LangStatus] || 'Authorize successfully', 'done');
        }
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    newPassword () {
      if(_.isEmpty(this.model.password_new)) { return this.$toastr.e(i18n_msg['newPassword_1'][this.LangStatus] || 'Typing new password'); }
      if(_.isEmpty(this.model.password_new_repeat)) { return this.$toastr.e(i18n_msg['newPassword_2'][this.LangStatus] || 'Typing new password repeat'); }
      if(this.model.password_new_repeat != this.model.password_new) { return this.$toastr.e(i18n_msg['newPassword_3'][this.LangStatus] || 'not same password and password repeat'); }

      let policy_count = -3
      if(this.group_password_policy.password_use_alphabet) { policy_count+=1 }
      if(this.group_password_policy.password_use_spacial) { policy_count+=1 }
      if(this.group_password_policy.password_use_number) { policy_count+=1 }

      // 그룹 정책에서 최소한의 정책이 없을 경우, 시스템 정책을 따른다
      if(policy_count < 0) {
        var rs = this.password_policy('all')
        if(rs.is_error) {
          var msg = rs.key.indexOf('is') > -1 ? rs.key.substring(3) : rs.key;
          return this.$toastr.e(i18n_msg['newPassword_4'][this.LangStatus] || `Please check password policy [${msg}]`);
        }
      } else {
        if(this.group_password_policy) {
          if(this.group_password_policy.password_use_alphabet && (!this.password_policy('uppercase') && !this.password_policy('lowercase'))) { return this.$toastr.e(i18n_msg['newPassword_5'][this.LangStatus] || "check password typing alphabet") }
          if(this.group_password_policy.password_use_spacial && !this.password_policy('spacial')) { return this.$toastr.e(i18n_msg['newPassword_6'][this.LangStatus] || "check password typing spacial") }
          if(this.group_password_policy.password_use_number && !this.password_policy('number')) { return this.$toastr.e(i18n_msg['newPassword_7'][this.LangStatus] || "check password typing number") }
          if(this.group_password_policy.password_min_len > 0 && !this.password_policy('length')) { return this.$toastr.e(i18n_msg['newPassword_8'][this.LangStatus] || "password length more then " + this.password_meter.min_length) }
        } else { return this.$toastr.e(i18n_msg['newPassword_9'][this.LangStatus] || "require group info") }
      }

      let user = {
        username : this.model.username,
        token : this.$route.query.token,
        new_password : forge.sha256.create().update(this.model.password_new).digest().toHex() // salt update
      }
      console.info(user)
      api.auth.ResetPassword(user).then(() => {
        alert(i18n_msg['newPassword_10'][this.LangStatus] || "changed successfully");
        this.$router.push({ name: 'auth_login' });
      }).catch(e => {
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText);
        this.model.password_new_repeat = "";
        this.model.password_new = "";
        this.model.password = "";
        this.lock = false;
      })
    },
    format(val, event) {
      if(!event) { return val; }
      let rs = val.replace(/-/g, '')
      if(rs.length <= 3) { return `${rs.substring(0, 3)}` }
      else if(rs.length <= 5) { return `${rs.substring(0, 3)}-${rs.substring(3, 5)}` }
      else { return `${rs.substring(0, 3)}-${rs.substring(3, 5)}-${rs.substring(5, 10)}` }
    },
  },

  created: function() { console.log('login.vue', 'created'); },
  destroyed: function() { console.log('login.vue', 'destroyed'); },
  mounted: function() {
    console.log('login.vue mounted');
    this.otpVerify()
    if(window.localStorage.getItem('username')) { this.checked = true; this.model.username = window.localStorage.getItem('username'); }
  }
}
